import { render, staticRenderFns } from "./main-section-primary.vue?vue&type=template&id=a77161de&scoped=true&"
import script from "./main-section-primary.vue?vue&type=script&lang=js&"
export * from "./main-section-primary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a77161de",
  null
  
)

export default component.exports